import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-285">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 p-4 md:hidden z-50 pointer-events-none" data-id="element-286">
          <div className="bg-white/95 backdrop-blur-md border border-hairline p-3 rounded-xl shadow-[0_-4px_20px_rgba(0,0,0,0.1)] pointer-events-auto flex items-center justify-between gap-4" data-id="element-287">
            <div className="flex flex-col pl-2" data-id="element-288">
              <span className="font-sans font-bold text-ink text-sm leading-tight" data-id="element-289">
                Protocolo Calma
              </span>
              <span className="font-sans font-bold text-coral text-lg leading-tight" data-id="element-290">
                $9.99
              </span>
            </div>
            <a href="https://www.tumundoequilibrado.com/cart/51386600358183:1" onClick={() => trackAddToCart()} className="bg-coral hover:bg-coral-dark text-white px-6 py-3 rounded-xl font-sans font-bold text-sm flex items-center gap-2 transition-colors shrink-0 shadow-soft" data-id="element-291">
              LO QUIERO <ArrowRightIcon className="w-4 h-4" data-id="element-292" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}